import ProduksiAsetApi from "./ProduksiAsetApi";

export default ProduksiAsetApi;
